if(typeof require !== 'undefined'){
    var $ = (typeof window.$ === 'function') ? window.$ : require('jquery');
}

function SystemsightAjaxFormHandler(options) {
    var defaults = {
        version: '1.1.5',
        formSelector: '[data-type="ajax"]',
        submitSelector: 'button[type="submit"]',
        preloaderElement: ' <div class="preloader spinner-border spinner-border-sm" role="status"><span class="sr-only">...</span></div>'
    };
    var that = this;
    options = options || {};

    that.formsIterator = 0;
    that.options = $.extend(true, {}, defaults, options);
    that.init();
}
SystemsightAjaxFormHandler.prototype.init = function () {
    var that = this;
    //start listening for submits
    $('body').on('submit', that.options.formSelector,function (e) {
        if(!$(this).attr('id')) {
            $(this).attr('id', 'ss_' + (++that.formsIterator));
        }
        that.handle_form_submit($(this), $(this).data('submit_invoker'));
        return false;
    }).on('click', `${that.options.formSelector} button[type="submit"], ${that.options.formSelector} input[type="submit"][formaction]`, function (e) {
        //sets submit action invoker
        $(this.form).data('submit_invoker', $(this));
    });

    console.info('SystemsightAjaxFormHandler inited (' + that.options.version + ')');
};

/**
 * @param {Object} $form
 * @param {Object=} $button
 */
SystemsightAjaxFormHandler.prototype.find_submit_btn = function($form, $button){
    var that = this;
    if(!$button){
        $button = $form.find(that.options.submitSelector);
    }
    return $button;
}

/**
 * Kai paspaudė submit'ino formą.
 * @param {Object} $form
 * @param {Object=} $button
 */
SystemsightAjaxFormHandler.prototype.handle_form_submit = function ($form, $button) {
    var that = this;
    that.show_preloader($form, $button);
    that.remove_form_feedbacks($form);

    var formData = $form.serializeArray();

    if($button && $button.attr('name')){
        formData.push(
            {
                name: $button.attr('name'),
                value: $button.val()
            }
        );
    }

    var action = $form.attr('action');
    if ($button && $button.attr('formaction')) {
        action = $button.attr('formaction');
    }

    $form.trigger('ajax-form.before-submit', [$button]);

    $.post(action, formData).done(function (r) {
        that.handle_form_submit_done($form, r);
        $form.trigger('ajax-form.done', [r]);
    }).always(function (e) {
        $form = that.get_updated_form_element($form);
        that.hide_preloader($form, $button);
        that.handle_form_submit_always($form);
        $form.trigger('ajax-form.always');
    }).fail(function (e) {
        that.handle_form_submit_fail($form, e);
        $form.trigger('ajax-form.fail');
    });
};

/**
 * @param {Object} $form
 * @param {Object=} $button
 */
SystemsightAjaxFormHandler.prototype.show_preloader = function ($form, $button) {
    var that = this;
    $button = that.find_submit_btn($form, $button);

    if($button.find('.preloader').length === 0){
        $button.append(that.options.preloaderElement);
    }
    $button.prop("disabled", true);
    $button.find('.preloader').removeClass('d-none');
};
/**
 * @param {Object} $form
 * @param {Object=} $button
 */
SystemsightAjaxFormHandler.prototype.hide_preloader = function ($form, $button) {
    var that = this;
    $button = that.find_submit_btn($form, $button);

    $button.prop("disabled", false);
    $button.find('.preloader').addClass('d-none');
};
/**
 * Remove errors from fields.
 * @param {Object} $form
 */
SystemsightAjaxFormHandler.prototype.remove_form_feedbacks = function ($form) {
    var that = this;
    $form.find('input,select,textarea')
        .removeClass('is-invalid is-valid')
        .parents('.form-group').removeClass('has-error').find('.invalid-feedback').html('')
    ;

    //jei tai simplemodule forma, tai tabus papildomai perziurim
    if($form.hasClass('simplemodule-form')){
        $form.find(".sm-edit-tabs a.nav-link").removeClass('is-invalid');
    }

};
/**
 * @param {Object} $form
 */
SystemsightAjaxFormHandler.prototype.handle_form_submit_always = function ($form) {
    var that = this;
    //reload captcha
    $form.find('input.captcha-input').each(function () {
        $(this).val('');
        if (typeof $(this).data('refresh') === 'function') {
            $(this).data('refresh')();
        }
    });
    //update fancybox
    if($form.parents('.fancybox-wrap').length){
        $.fancybox.update()
    }
}
/**
 * @param {Object} $form
 * @param {Object} event
 */
SystemsightAjaxFormHandler.prototype.handle_form_submit_fail = function ($form, event) {
    var that = this;
    that.display_messages($form, {
        message: {
            type: 'danger',
            text: event.status + " " + event.statusText
        }
    });
};
/**
 * @param {Object} $form
 * @param {Object} response JSON object response
 */
SystemsightAjaxFormHandler.prototype.handle_form_submit_done = function ($form, response) {
    var that = this;

    if(typeof response === 'string'){
        that.display_messages($form, {
            message: {
                type: 'danger',
                text: response
            }
        });
        return;
    }

    $form.trigger( "on_form_submit_done", [ response ] );//listens in `preview.js`

    if(response.status == "ok"){
        //
    }else{
        that.mark_errors(response.errors, $form);
    }

    if(typeof response.transformed_data === 'object'){
        for(var fieldName in response.transformed_data){
            var $field = $form.find('[name="'+fieldName+'"],[data-input_name="'+fieldName+'"]');
            //todo: check radio or checkbox types
            if (
                $field.attr('type')
                && $field.attr('type') != 'file'
            ) {
                $field.val(response.transformed_data[fieldName]);
            }
        }
    }


    if(typeof response.message !== 'undefined'){
        that.display_messages($form, response);
    }

    if(typeof response.modal === 'string'){
        that.display_modal($form, response.modal, response);
    }

    if(typeof response.modal_body === 'string'){
        that.display_modal(
            $form,
            that.get_modal_html(response.modal_body),
            response
        );
    }

    if(typeof response.replace_with === "string"){
        var $r = $(response.replace_with);
        if(response.target){
            $(response.target).replaceWith($r);
        }else{
            $form.replaceWith($r);
            $form = $r;
        }

    }

    that.run_form_callback(response)

    if(typeof response.redirect === "string"){
        window.location.href = response.redirect;
    }

};

SystemsightAjaxFormHandler.prototype.run_form_callback = function (response) {
    var that = this;
    if(typeof response.callback === 'string'){
        that.eval_callback(response.callback, response.nonce);
    }

    if(typeof response.callbacks == "object" && Array.isArray(response.callbacks )){
        response.callbacks.forEach((callback) => {
            that.eval_callback(callback, response.nonce);
        })
    }

}
SystemsightAjaxFormHandler.prototype.eval_callback = function (evalValue, nonce) {
    var $script = $('<script nonce="' + nonce + '">' + evalValue + '</script>')
    $('body').append($script)
    $script.remove();
}

/**
 * @param {Array.<string, string>} errors
 * @param {Object} $form
 */
SystemsightAjaxFormHandler.prototype.mark_errors = function (errors, $form) {
    for(var fieldName in errors){
        var $field = $form.find('[name="'+fieldName+'"],[name="'+fieldName+'[]"],[data-input_name="'+fieldName+'"]');
        $field.addClass('is-invalid')
            .closest('.form-group')
            .addClass('has-error')
            .find('.invalid-feedback')
            .html(errors[fieldName]);
    }
}
/**
 * @param {Object} $form
 */
SystemsightAjaxFormHandler.prototype.get_updated_form_element = function ($form) {
    if($form.attr('id')) {
        return $('#' + $form.attr('id')); //Select updated DOM element
    } else {
        return $form;
    }
};
/**
 * @param {Object} $form
 * @param {string} modal modal HTML
 * @param {Object} response JSON Object
 */
SystemsightAjaxFormHandler.prototype.display_modal = function ($form, modal, response){
    var that = this;
    var $modal = $(modal);
    $('body').append($modal);
    let bsModal = new bootstrap.Modal($modal[0], {});

    var redirect = null;
    //padarom redirecta tik poto kai uzdaromas modal'as
    if(typeof response.redirect === 'string') {
        redirect = response.redirect
        delete response.redirect;
    }
    var callback = null
    var callbacks = null
    //padarom callback tik poto kai uzdaromas modal'as
    if(typeof response.callback === 'string') {
        callback = response.callback
        delete response.callback;
    }

    if(typeof response.callbacks == "object" && Array.isArray(response.callbacks )){
        callbacks = response.callbacks
        delete response.callbacks;
    }

    $modal.on('hidden.bs.modal', function (event) {
        bsModal.dispose()
        $modal.remove();

        if(redirect){
            window.location.href = redirect;
        }
        if(callback){
            that.eval_callback(callback, response.nonce)
        }

        if(callbacks){
            callbacks.forEach((callback) => {
                that.eval_callback(callback, response.nonce);
            })
        }
    })
    bsModal.show()


};
/**
 * @param {Object} $form
 * @param {Object} response JSON Object
 */
SystemsightAjaxFormHandler.prototype.display_messages = function ($form, response){
    var that = this;
    var modalBody = '';
    if(typeof response.message == "object"){
        if(Array.isArray(response.message )){
            if(response.message.length === 1){
                $.each(response.message, function (index, msg) {
                    if(typeof msg == "object"){
                        modalBody += '<img src="/Project/Modules/General/Admin/assets/images/icons/icon-'+ msg.type +'.svg"/>' +
                        '<h5 class="modal-title">'+msg.text+'</h5>';
                    }else{
                        modalBody += '<img src="/Project/Modules/General/Admin/assets/images/icons/icon-info.svg"/>' +
                            '<h5 class="modal-title">'+msg+'</h5>';
                    }
                })
            } else {
                $.each(response.message, function (index, msg) {
                    if(index === 0 ) {
                        if(typeof msg == "object"){
                            modalBody += '<img src="/Project/Modules/General/Admin/assets/images/icons/icon-'+ msg.type +'.svg"/>' +
                                '<h5 class="modal-title">'+msg.text+'</h5>';
                        }else{
                            modalBody += '<img src="/Project/Modules/General/Admin/assets/images/icons/icon-info.svg"/>' +
                                '<h5 class="modal-title">'+msg+'</h5>';
                        }
                    } else{
                        if(typeof msg == "object"){
                            modalBody +=  '<h5 class="modal-title">'+msg.text+'</h5>';
                        }else{
                            modalBody += '<h5 class="modal-title">'+msg+'</h5>';
                        }
                    }
                })
            }
        }else{
            modalBody += '<img src="/Project/Modules/General/Admin/assets/images/icons/icon-'+ response.message.type +'.svg"/>' +
                '<h5 class="modal-title">'+response.message.text+'</h5>';
        }
    }else{
        modalBody += '<img src="/Project/Modules/General/Admin/assets/images/icons/icon-info.svg"/>' +
            '<h5 class="modal-title">'+response.message+'</h5>';
    }
    if(modalBody){
        that.display_modal($form, that.get_modal_html(modalBody), response);
    }
}

/**
 * @param {string} modalBody
 */
SystemsightAjaxFormHandler.prototype.get_modal_html = function (modalBody) {
    var that = this;
    var modalHtml =
        '<div class="modal fade modal-ajax-form" tabindex="-1" aria-hidden="true" data-bs-keyboard="false" data-bs-backdrop="static">'
        + '<div class="modal-dialog modal-dialog-centered">'
        + '<div class="modal-content">'
            + '<div class="modal-header">'
            + '<button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>'
            +'</div>'
            + '<div class="modal-body">'+modalBody+'</div>'
            +'<div class="modal-footer py-3">'
            +'<button type="button" class="btn btn-primary close-modal" data-bs-dismiss="modal" aria-label="Close">Uždaryti</button>'
            +'</div>'
        + '</div>'
        + '</div>'
        + '</div>';

    return modalHtml;
};


if (typeof module === "object" && typeof module.exports === "object"){
    //node modules support
    module.exports = new SystemsightAjaxFormHandler();
}else{
    var systemsightAjaxFormHandler;
    $(document).ready(function () {
        systemsightAjaxFormHandler = new SystemsightAjaxFormHandler();
    });
}
